export enum EDefaultValues {
  EMPTY_STRING = "--",
}
